import {setSimulations} from "@/redux/slices/commonSlices/viewTabsSlice";

import logoMedicalViolet from "@images/general/ava_medical_violet_logo_EN.png";
import logoMedicalWhite from "@images/general/ava_medical_white_logo_EN.png";
import logoVioletEn from "@images/general/ava_trainer_violet_logo_EN.png";
import logoVioletRu from "@images/general/ava_trainer_violet_logo_RU.png";
import logoWhiteEn from "@images/general/ava_trainer_white_logo_EN.png";
import logoWhiteRu from "@images/general/ava_trainer_white_logo_RU.png";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const Logo = ({direction}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {auth} = useSelector((state) => state.common.candidate);
  const {language} = useSelector((state) => state.common.settings);

  const isMedical = window.location.host.includes("ava-medical");

  const handleClickLogo = () => {
    if (auth) {
      navigate("/simulations/call");
      dispatch(setSimulations("call"));
    } else {
      navigate("/");
    }
  };

  if (direction === "footer") {
    return (
      <div className={styles.footerLogo}>
        <img
          onClick={handleClickLogo}
          src={
            isMedical
              ? logoMedicalWhite
              : language === "ru"
                ? logoWhiteRu
                : logoWhiteEn
          }
          alt={"logo"}
        />
      </div>
    );
  } else {
    return (
      <div
        className={
          location.pathname.includes("login") ? styles.logoHero : styles.logo
        }
      >
        <img
          onClick={handleClickLogo}
          src={
            isMedical
              ? logoMedicalViolet
              : language === "ru"
                ? logoVioletRu
                : logoVioletEn
          }
          alt={"logo"}
        />
      </div>
    );
  }
};
